class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  async renderContents(parsedState) {
    const renderSequence = this.renderSequence = (this.renderSequence || 0) + 1;
    let contents = this.getRenderedSections(parsedState?.sections);
    if (!contents) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', this.getSectionsToRender().map(section => section.id).join(','));
        const response = await fetch(url.pathname + url.search, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (response.ok) contents = this.getRenderedSections(await response.json());
      } catch {}
    }
    if (renderSequence !== this.renderSequence) return false;
    if (!contents) {
      const url = new URL(window.routes?.cart_url || '/cart', window.location.origin);
      const parameters = new URLSearchParams(window.location.search);
      for (const name of ['preview_theme_id', '_fd', '_sc']) {
        const value = parameters.get(name);
        if (value !== null) url.searchParams.set(name, value);
      }
      window.location.assign(url.pathname + url.search);
      return false;
    }
    this.productId = parsedState?.id;
    contents.forEach(({ element, html }) => { element.innerHTML = html; });
    this.classList.toggle('is-empty', Boolean(this.querySelector('.drawer__inner-empty')));

    setTimeout(() => {
      if (renderSequence !== this.renderSequence || !this.isConnected) return;
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    return true;
  }

  getRenderedSections(sections) {
    if (!sections || typeof sections !== 'object') return null;
    const contents = [];
    for (const section of this.getSectionsToRender()) {
      const element = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      const source = sections[section.id];
      if (!element || typeof source !== 'string' || !source.trim()) return null;
      const rendered = this.getSectionDOM(source, section.selector);
      if (!rendered || (section.id === 'cart-drawer' && (!rendered.querySelector('.drawer__inner') || !rendered.querySelector('#CartDrawer-Overlay')))) return null;
      contents.push({ element, html: rendered.innerHTML });
    }
    return contents;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
